import React, { Component } from "react";
import {
  Container,
  Divider,
  Header,
  Image,
  Segment,
  Placeholder,
  Button
} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";

class Events extends Component {

  state = { loadingExpoImage: true, loadingWorkshopImage: true };

  constructor(props) {
    super(props);
    this.handleExpoImageLoad = this.handleExpoImageLoad.bind(this);
    this.handleWorkshopImageLoad = this.handleWorkshopImageLoad.bind(this);
    this.recruitmentDone = true;
  }

  handleExpoImageLoad() {
    this.setState({ loadingExpoImage: false });
  }

  handleWorkshopImageLoad() {
    this.setState({ loadingWorkshopImage: false });
  }

  render() {
    return (
      <Segment style={{ padding: "3em 0em" }} vertical>
        <Container text>
          <Divider
            as="h3"
            className="header"
            horizontal
            style={{ margin: "3em 0em", textTransform: "uppercase" }}
          >
            <p>Club Events</p>
          </Divider>
          <Header as="h4" style={{ fontSize: "2em" }}>
            Expo
          </Header>
          <p style={{ fontSize: "1.2em" }}>
            All projects done for the academic year by our Club will be put to
            display and presentation during Expo. All Club Members mainly
            including 2nd years and 3rd years, exhibit their projects.
          </p>
          <div>
            <Image
              centered
              hidden={true}
              src={CONSTANTS.EXPO_IMAGE}
              onLoad={this.handleExpoImageLoad}
            />
            {this.state.loadingExpoImage ? (
              <Placeholder>
                <Placeholder.Image rectangular />
              </Placeholder>
            ) : (
              <Image
                centered
                rounded
                fluid
                src={CONSTANTS.EXPO_IMAGE}
                onLoad={this.handleExpoImageLoad}
              />
            )}
          </div>

          {/*<Divider
            as="h3"
            className="header"
            horizontal
            style={{ margin: "3em 0em", textTransform: "uppercase" }}
          >
            <p>Club Events</p>
          </Divider>
          <Header as="h4" style={{ fontSize: "2em" }}>
            Workshop
          </Header>
          <p style={{ fontSize: "1.2em" }}>
            RCS conducts a basic Robotics Workshop. The club has been doing this
            since many years under the name "OLP" as Open Learning Program. Last
            year, RCS has collaborated with TBI at SASTRA to conduct the
            Workshop.
          </p>
          <div>
            <Image
              centered
              hidden={true}
              src={CONSTANTS.WORKSHOP_IMAGE}
              onLoad={this.handleWorkshopImageLoad}
            />
            {this.state.loadingWorkshopImage ? (
              <Placeholder>
                <Placeholder.Image rectangular />
              </Placeholder>
            ) : (
              <Image
                centered
                rounded
                size='medium'
                src={CONSTANTS.WORKSHOP_IMAGE}
                onLoad={this.handleWorkshopImageLoad}
              />
            )}
          </div>
          <Button as="a" size="large">
            Read More
          </Button>*/}
        </Container>
      </Segment>
    );
  }
}

export default Events;
